
import request from '@/utils/request';
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const newParams = {...params};
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }
    
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }
  //console.log(`api.dept-user.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/dept-user?${qsParams.toString()}`,
    method: 'get',
    data: newParams
  })
}
function get (itemId) {
  return request({
    url: `/dept-user/${itemId}`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/dept-user/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  ENABLE_API_DBG && console.log(`api.deptUser.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/dept-user`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/dept-user/${params.id}`,
    method: 'patch',
    data: params
  })
}
function remove (itemId) {
  const url = `/dept-user/${itemId}`;
  ENABLE_API_DBG && console.log(`api.deptUser.remove: url = ${url}`)
  return request({
    url,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
}
